import {Injectable} from '@angular/core';
declare let $: any;

@Injectable({ providedIn: 'root' })
export class ValidateService {
    blurComponent: any = {};
    validatePattern(pattern, value) {
        const re = new RegExp(pattern);
        return re.test(value);
    }
    checkBlur(id) {
        this.blurComponent = {};
        let ids = [];
        if (typeof id === 'object') {
            ids = id;
        } else {
            ids = [id];
        }
        ids.forEach((code) => {
            // this.blurComponent[code] = true;
            $('#' + code).focus(() => {
                this.blurComponent[code] = false;
            });
            $('#' + code).blur(() => {
                this.blurComponent[code] = true;
            });
            $('.' + code).focus(() => {
                this.blurComponent[code] = false;
            });
            $('.' + code).blur(() => {
                this.blurComponent[code] = true;
            });
        });
    }
    getValue(id) {
        return this.blurComponent[id];
    }
    setValue(code) {
        this.blurComponent[code] = true;
    }
    hasError() {
        const error = $('.error-text');
        if (error && error.length > 0) {
        return true;
        }
        return false;
    }
}
